/* eslint-disable no-unused-vars,jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import {
  selectAuthAccountData,
  sendGetAuthAccountDataRequest
} from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { addClientNotice } from 'mt-react-common/modules/main/reducers/static/states/clientNotices/reducer';

import OpacityPreLoader from '../../Common/PreLoaders/OpacityPreLoader';
import UserService from '../../../mt-react-common/modules/users/services/UserService';

class UserAuthTypeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authType: props.userAuthAccount.authSecureType,
      loading: false
    };
  }

  changeAuthTypeParam(authType) {
    this.setState({ authType });
  }

  // Выйти из группы
  sendRequest = () => {
    this.setState({ loading: true });
    UserService.changeAuthType({
      authType: this.state.authType
    }).then(result => {
      if (result) {
        if (result.status === 200) {
          this.props.refreshAuthAccountData();
          this.props.addClientNotice({
            type: 'success',
            message: t('Настройки безопасного входа сохранены')
          });
        }
      }
      this.setState({ loading: false });
    });
  };

  render() {
    return (
      <div className="panel panel-default panel-heading_padding-large panel-body_bg-sub panel-footer_padding-large pos-rel">
        <div className="panel-heading text-center">
          <h2 className="panel-title">
            <i className="fa fa-lock" /> {t('Настройки безопасного входа')}
          </h2>
        </div>
        <form
          className="pos-rel ng-untouched ng-pristine ng-invalid"
          noValidate=""
        >
          {this.state.loading ? <OpacityPreLoader /> : null}
          <div className="panel-body">
            <div className={`form-group`}>
              <div className="control-group">
                <div className="radio abc-radio">
                  <input
                    checked={this.state.authType === 0}
                    onChange={() => {
                      this.changeAuthTypeParam(0);
                    }}
                    type="radio"
                    name="authType"
                    id="authType0"
                  />
                  <label htmlFor="authType0">
                    <strong>{t('Без подтверждения входа')}</strong>
                    <br />
                    {t(
                      'Вход после ввода логина и пароля. Если у вас слабый пароль или злоумышленник узнает ваши данные - он сможет войти в ваш аккаунт'
                    )}
                  </label>
                </div>
                <div className="radio abc-radio">
                  <input
                    checked={this.state.authType === 1}
                    onChange={() => {
                      this.changeAuthTypeParam(1);
                    }}
                    type="radio"
                    name="authType"
                    id="authType1"
                  />
                  <label htmlFor="authType1">
                    <strong>
                      {t(
                        'Подтверждать вход из подозрительных мест через почту'
                      )}
                    </strong>
                    <br />
                    {t(
                      'Если IP-адрес при авторизации не совпадает с IP-адресом последнего входа - вам на почту будет отправлена ссылка для подтверждения входа'
                    )}
                  </label>
                </div>
                <div className="radio abc-radio">
                  <input
                    checked={this.state.authType === 2}
                    onChange={() => {
                      this.changeAuthTypeParam(2);
                    }}
                    type="radio"
                    name="authType"
                    id="authType2"
                  />
                  <label htmlFor="authType2">
                    <strong>{t('Всегда подтверждать вход через почту')}</strong>
                    <br />
                    {t(
                      'После ввода логина и пароля, вам на почту будет отправлена ссылка для подтверждения входа'
                    )}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="panel-footer">
            <div className="btn-toolbar">
              <a
                className="btn btn-primary"
                data-toggle="modal"
                href={null}
                onClick={() => {
                  this.sendRequest();
                }}
              >
                {t('Сохранить')}
              </a>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

UserAuthTypeForm.propTypes = {
  reduxState: PropTypes.shape({}).isRequired,
  addClientNotice: PropTypes.func.isRequired,
  refreshAuthAccountData: PropTypes.func.isRequired,
  userAuthAccount: PropTypes.shape({
    authSecureType: PropTypes.number.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  userAuthAccount: selectAuthAccountData(state),
  reduxState: state
});

const mapDispatchToProps = dispatch => ({
  addClientNotice: params => dispatch(addClientNotice(params)),
  refreshAuthAccountData: params =>
    dispatch(sendGetAuthAccountDataRequest(params))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserAuthTypeForm)
);



// WEBPACK FOOTER //
// ./src/components/UserAccount/UserAuthTypeForm/UserAuthTypeForm.js